import React, { useEffect, useState } from 'react';

function MobileNotice() {
    return (
        <div style={{
            height: '100vh',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            backgroundColor: '#262c36',
            padding: '2rem',
            fontFamily: 'inherit'
        }}>
            <h1>Please Use a Desktop</h1>
            <p>Portrait mode on small screens is currently in development. Thank you for your patience!</p>
        </div>
    );
}

export default function ScreenWrapper({ children }) {
    const [isSmallScreen, setIsSmallScreen] = useState(false);

    useEffect(() => {
        const checkScreen = () => {
            setIsSmallScreen(window.innerWidth / window.innerHeight < 1); // adjust threshold as needed
        };
        checkScreen();
        window.addEventListener('resize', checkScreen);
        return () => window.removeEventListener('resize', checkScreen);
    }, []);

    return isSmallScreen ? <MobileNotice /> : children;
}